import React from 'react'
import HeroSection from '../HeroSection'
import Category from '../Category'
import Career from '../Career'
import JobArea from '../JobArea'
import ComapanyDashboard from '../Topemployer'
import Process from '../Process'

const HomePage = () => {
  return (
    <>
      <div class="preloader" style={{display: "none"}}>
        <div class="loader">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div className='main' >
        <HeroSection />
        <Category/>
        <Career/>
        <JobArea/>
        <Process/>
        <ComapanyDashboard/>
      </div>
    </>
  )
}

export default HomePage
